module.exports = __webpack_public_path__ + "static/media/financeiro.65ccb1d2.svg";